import request from "@/utils/request1";
import baseURL from "@/utils/baseUrl1";
// import fileRequest from "@/utils/fileRequest";

const letterService = {}
let base_url = baseURL.platform

/**
 *获取默认的归口单位
 */
letterService.defaultAdminUnit= function (params) {
    return request({
        url: "/letter/defaultAdminUnit",
        method: "post",
        data:params,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *信件发布
 */
letterService.publish= function (params) {
    return request({
        url: "/letter/publish",
        method: "get",
        params:params,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *查询信件列表-已公开
 */
letterService.queryOpenLetter= function (params) {
    return request({
        url: "/letter/public/queryOpenLetter",
        method: "post",
        data:params,
        baseURL: baseURL.platformNotAuth,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *信件受理详情
 */
letterService.queryOpenLetterDetail= function (params) {
    return request({
        url: "/letter/public/queryOpenLetterDetail",
        method: "get",
        params:params,
        baseURL: baseURL.platformNotAuth,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}

/**
 *信件详情
 */
letterService.queryLetterDetail= function (params) {
    return request({
        url: "/platform/queryLetterDetail",
        method: "get",
        params:params,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *信件受理
 */
letterService.accept= function (params) {
    return request({
        url: "/letter/accept",
        method: "get",
        params:params,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}

/**
 *信件回复
 */
letterService.reply= function (params) {
    return request({
        url: "/letter/reply",
        method: "post",
        data:params,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *保存信件内容
 */
letterService.saveLetter= function (params) {
    return request({
        url: "/letter/saveLetter",
        method: "post",
        data:params,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}

/**
 *查询信件列表--归口单位咨询/建议
 */
letterService.queryAdminUnitLetter= function (params) {
    return request({
        url: "/letter/queryAdminUnitLetter",
        method: "post",
        data:params,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *查询信件列表-我的咨询/建议
 */
letterService.queryMyLetter= function (params) {
    return request({
        url: "/letter/queryMyLetter",
        method: "post",
        data:params,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}
/**
 *查询信件列表-专办
 */
letterService.querySpecialLetter= function (params) {
    return request({
        url: "/letter/querySpecialLetter",
        method: "post",
        data:params,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}


/**
 *get方法
 */
letterService.platformDetail= function (params) {
    return request({
        url: "/platform/platformDetail",
        method: "get",
        params:params,
        baseURL: base_url,
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        }
    });
}



// //下载
// letterService.downloadFile = function (params, fileName) {
//     return fileRequest({
//         url: "/projectTypeCount/export",
//         method: "post",
//         data:params,
//         baseURL: baseURL.platform,
//         headers: {
//             "Content-Type": "application/json; charset=UTF-8"
//         }
//     }).then(res => {
//         if (window.navigator.msSaveOrOpenBlob) {
//             navigator.msSaveBlob(res, fileName)
//         } else {
//             let link = document.createElement('a');
//             link.href = window.URL.createObjectURL(new Blob([res]));
//             link.download = fileName;
//             link.click();
//             window.URL.revokeObjectURL(link.href)
//         }
//     }).catch(res => {
//         return Promise.reject(res);
//     });
// }

export default letterService